import {
  theme as pdcTheme,
  overrideComponents,
  PDCThemeOptions,
  PDCCreateTheme,
} from '@mzc-pdc/ui';

export const projectTheme = {
  ...pdcTheme,
  palette: {
    ...pdcTheme?.palette,
    divider: `#dfdfee`
  },
  typography: {
    ...pdcTheme.typography,
  },
  mixins: {
    toolbar: {
      minHeight: `56px`,
      '@media (min-width: 600px)': {
        minHeight: '56px',
      },
    },
  },
  breakpoints: {
    ...pdcTheme.breakpoints,
    values: {
      ...pdcTheme.breakpoints.values,
      xxxl: 1650,
    },
  },
  zIndex: {
    appBar: 500,
    drawer: 500,
    modal: 900,
  },
  // spacing: (factor) => `${factor*0.5}rem`
};

export const projectOverrideTheme: PDCThemeOptions = {
  ...projectTheme, // pdc/ui에 있는 theme
  components: {
    ...overrideComponents(projectTheme),
    MuiCssBaseline: {
      styleOverrides: `
      html {
        overflow: hidden;
        font-size: 16px;
    }
    html,body,#root {
      height: 100%;
    }
    .container {
        height: 100%;
    }
    body, button, input, select, textarea {
        font-family: 'Noto Sans KR', sans-serif;
        color: #3c3d4f;
    }
    a {
      color: inherit;
      text-decoration: none;
    }
    a:focus {
      //outline: thin dotted;
      outline: 0;
    }
    a:hover,
    a:active {
      outline: 0;
    }
    main::-webkit-scrollbar,
    div::-webkit-scrollbar ,
    ul::-webkit-scrollbar {
          width: 14px;
          height: 14px;
        }
    main::-webkit-scrollbar-track,
    div::-webkit-scrollbar-track ,
    ul::-webkit-scrollbar-track {
          background: transparent;
        }
    main::-webkit-scrollbar-thumb,
    div::-webkit-scrollbar-thumb ,
    ul::-webkit-scrollbar-thumb {
          background-color: #dce1e5;
          border-radius: 8px;
          background-clip: padding-box;
          border: 4px solid transparent;
        }
     .MuiButtonBase-root[aria-expanded="true"] {
        background-color: rgba(0, 0, 0, 0.04);
     }
     button {
         margin: 0;
         padding: 0;
         border: none;
         background-color: transparent;
     }
     address {
      font-style: normal;
     }
    `,
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          marginTop: `4px !important`,
        },
      },
    },
    MuiButton: {
      ...overrideComponents(projectTheme).MuiButton,
      variants: [
        {
          props: {size: 'xsmall'},
          style: {
            height: 24,
            fontSize: 12,
          },
        },
      ],
    },
  }

};


const theme = PDCCreateTheme(projectOverrideTheme);
// console.log(theme)
export default theme;
